<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M12 8.39844V16.3984M8 12.3984H16M22 12.3984C22 17.9213 17.5228 22.3984 12 22.3984C6.47715 22.3984 2 17.9213 2 12.3984C2 6.87559 6.47715 2.39844 12 2.39844C17.5228 2.39844 22 6.87559 22 12.3984Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
